var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-company",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.742,
    height: 21.739,
    viewBox: "0 0 21.742 21.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M168.575,177.618h1.553a.776.776,0,1,1,0,1.553H149.939a.776.776,0,1,1,0-1.553h1.555V165.2a.777.777,0,0,1,.776-.776h5.435v-6.211a.777.777,0,0,1,1.022-.737l9.317,3.106a.777.777,0,0,1,.531.737Zm-1.553,0V161.874l-7.764-2.588v5.134h1.553a.777.777,0,0,1,.776.776h3.106a.776.776,0,1,1,0,1.553h-3.106V168.3h3.106a.776.776,0,0,1,0,1.553h-3.106v1.553h3.106a.776.776,0,1,1,0,1.553h-3.106v1.553h3.106a.776.776,0,1,1,0,1.553h-3.106v1.553Zm-8.54,0h1.553V165.972h-6.988v11.646H154.6v-3.106a.777.777,0,0,1,.776-.776h2.329a.777.777,0,0,1,.776.776Zm-1.553,0v-2.329h-.776v2.329Zm-1.553-5.435h2.329a.776.776,0,0,0,0-1.553h-2.329a.776.776,0,1,0,0,1.553Zm0-3.106h2.329a.776.776,0,0,0,0-1.553h-2.329a.776.776,0,1,0,0,1.553Zm6.211-5.435h3.106a.776.776,0,0,0,0-1.553h-3.106a.776.776,0,0,0,0,1.553Z",
    transform: "translate(-149.163 -157.432)",
    fill: "#006866",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.74c214c4dfe1392e63429af4e646f4fb.svg";
export { ForwardRef as ReactComponent };